import React, { useState, useEffect, useContext } from "react";
import { UserAuthContext } from "../../../App";
import { getAuth } from "@firebase/auth";
import {
  allProductIdApi,
  toggleWishlistApi,
  wishlistApi,
} from "../../../Apis/ProductApi";
import { useNavigate } from "react-router-dom";
import { createInquiryApi } from "../../../Apis/EnquiryApi";
import { CurrencyContext } from "../../../provider/CurrencyProvider";

const ProductsCard = ({
  storeDetails,
  selectedCategory,
  min,
  max,
  selectedSubCategory,
  sortType,
  sellerTypes,
  rating,
}) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const { userUid } = useContext(UserAuthContext);
  const [allProductsData, setAllProductsData] = useState([]);
  const [wishList, setWishList] = useState([]);
  const [products, setProducts] = useState([]);
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showInquirySent, setShowInquirySent] = useState(false);
  const [inquiryContact, setInquiryContact] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.phoneNumber : ""
  );
  const [inquiryEmail, setInquiryEmail] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.email : ""
  );
  const [inquiryContent, setInquiryContent] = useState("");
  const [inquiryQuantity, setInquiryQuantity] = useState("");

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);

  const handleViewAllInquiries = () => {
    navigate("/orders/inquiry");
  };

  const toggleLike = async (productId, liked) => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    await toggleWishlistApi(userUid?.currentUser?.uid, productId, !liked);
    setRefresh(!refresh);
  };

  const getWishlistData = async () => {
    const response = await wishlistApi(userUid?.currentUser?.uid);
    setWishList(response?.wishList?.wishlistJson);
  };

  const getProductsData = async () => {
    try {
      const response = await allProductIdApi(
        page,
        selectedCategory,
        min,
        max,
        selectedSubCategory,
        sortType,
        sellerTypes,
        rating
      );
      if (response?.products?.length > 0) {
        const products = response.products;
        const wishListMap = {};
        wishList?.forEach((productId) => {
          wishListMap[productId] = true;
        });

        const updatedProducts = products.map((product) => ({
          data: product,
          liked: wishListMap[product.productID] || false,
        }));

        setAllProductsData((prevProducts) => {
          if (
            selectedCategory ||
            min != null ||
            max != null ||
            selectedSubCategory ||
            sortType ||
            sellerTypes ||
            rating
          ) {
            return updatedProducts;
          } else {
            const updatedData = prevProducts?.filter(
              (prevProduct) =>
                !products.some(
                  (product) => product.productID === prevProduct.data.productID
                )
            );
            return [...updatedData, ...updatedProducts];
          }
        });
      } else {
        // No products found for the selected filters
        setAllProductsData([]);
      }
    } catch (error) {
      console.log("Error fetching products", error);
      setAllProductsData([]);
    }
  };

  useEffect(() => {
    if (userUid?.currentUser?.uid) getWishlistData();
  }, [refresh, userUid?.currentUser?.uid]);

  useEffect(() => {
    getProductsData();
  }, [
    wishList?.length,
    page,
    selectedCategory,
    min,
    max,
    selectedSubCategory,
    sortType,
    sellerTypes,
    rating,
  ]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;

      if (scrollTop + clientHeight >= scrollHeight) setPage((prev) => prev + 1);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleInquiryClick = (product) => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }
    setSelectedProduct(product);
    setShowInquiryForm(true);
  };

  const handleCloseInquiryForm = () => {
    setShowInquiryForm(false);
    setSelectedProduct(null);
  };

  const handleSendInquiry = async () => {
    await createInquiryApi(
      selectedProduct.productID,
      userUid?.currentUser?.uid,
      selectedProduct.storeID,
      inquiryContact,
      inquiryQuantity,
      inquiryEmail,
      inquiryContent
    );

    setShowInquiryForm(false);
    setShowInquirySent(true);

    setInquiryContact("");
    setInquiryQuantity("");
    setInquiryEmail("");
    setInquiryContent("");
  };

  const handleCloseInquirySent = () => {
    setShowInquirySent(false);
  };

  return (
    <>
      <div className="w-full h-[787px] mt-[18px] flex flex-wrap gap-[18px]">
        {allProductsData &&
          allProductsData?.map((item, index) => (
            <>
              <button
                key={index}
                className="w-[224px] h-[375px] bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] text-left"
              >
                <div className="w-full flex flex-col h-[162px] bg-[#F8F8F8] pt-[14px] pb-[10px] px-[14px] rounded-t-[10px]">
                  <div className="flex flex-row items-start justify-between w-[196px] h-[110px]">
                    <div className="w-[133px] h-[110px] flex items-center justify-end">
                      {item?.data?.images && item?.data?.images?.length > 0 && (
                        <img
                          src={item?.data?.images[0]}
                          alt="ProductImg"
                          className="w-[87px] h-[87px]"
                          onClick={() => {
                            // console.log(item);
                            navigate(`/productId/${item?.data?.productID}`, {
                              state: item?.data?.productID,
                            });
                          }}
                        />
                      )}
                    </div>
                    <button
                      className={`w-[22px] h-[22px] flex items-center bg-white rounded-full justify-center ${
                        item?.liked ? "" : "text-[#D3D3D3]"
                      }`}
                      onClick={() =>
                        toggleLike(item?.data?.productID, item?.liked)
                      }
                    >
                      {item?.liked ? (
                        <>
                          <div className="bg-white text-[#FF6300] flex items-center justify-center w-[22px] h-[22px] rounded-full">
                            <svg
                              width="14"
                              height="12"
                              viewBox="0 0 14 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7 11.5725C6.87426 11.5725 6.76786 11.529 6.6808 11.442L2.15402 7.07478C2.10565 7.03609 2.03916 6.97321 1.95452 6.88616C1.86988 6.79911 1.73568 6.64072 1.5519 6.41099C1.36812 6.18127 1.20368 5.9455 1.05859 5.70368C0.913504 5.46187 0.784133 5.16927 0.67048 4.82589C0.556827 4.48251 0.5 4.14881 0.5 3.82478C0.5 2.76079 0.807106 1.92894 1.42132 1.32924C2.03553 0.729539 2.8843 0.429688 3.96763 0.429688C4.26748 0.429688 4.57338 0.481678 4.88532 0.585658C5.19727 0.689639 5.48744 0.829892 5.75586 1.00642C6.02427 1.18294 6.25521 1.34859 6.44866 1.50335C6.64211 1.65811 6.82589 1.82254 7 1.99665C7.17411 1.82254 7.35789 1.65811 7.55134 1.50335C7.74479 1.34859 7.97573 1.18294 8.24414 1.00642C8.51256 0.829892 8.80273 0.689639 9.11468 0.585658C9.42662 0.481678 9.73251 0.429688 10.0324 0.429688C11.1157 0.429688 11.9645 0.729539 12.5787 1.32924C13.1929 1.92894 13.5 2.76079 13.5 3.82478C13.5 4.8936 12.9462 5.98177 11.8387 7.08929L7.3192 11.442C7.23214 11.529 7.12574 11.5725 7 11.5725Z"
                                fill="#FF3E3E"
                              />
                            </svg>
                          </div>
                        </>
                      ) : (
                        <>
                          <svg
                            width="14"
                            height="12"
                            viewBox="0 0 14 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 11.5725C6.87426 11.5725 6.76786 11.529 6.6808 11.442L2.15402 7.07478C2.10565 7.03609 2.03916 6.97321 1.95452 6.88616C1.86988 6.79911 1.73568 6.64072 1.5519 6.41099C1.36812 6.18127 1.20368 5.9455 1.05859 5.70368C0.913504 5.46187 0.784133 5.16927 0.67048 4.82589C0.556827 4.48251 0.5 4.14881 0.5 3.82478C0.5 2.76079 0.807106 1.92894 1.42132 1.32924C2.03553 0.729539 2.8843 0.429688 3.96763 0.429688C4.26748 0.429688 4.57338 0.481678 4.88532 0.585658C5.19727 0.689639 5.48744 0.829892 5.75586 1.00642C6.02427 1.18294 6.25521 1.34859 6.44866 1.50335C6.64211 1.65811 6.82589 1.82254 7 1.99665C7.17411 1.82254 7.35789 1.65811 7.55134 1.50335C7.74479 1.34859 7.97573 1.18294 8.24414 1.00642C8.51256 0.829892 8.80273 0.689639 9.11468 0.585658C9.42662 0.481678 9.73251 0.429688 10.0324 0.429688C11.1157 0.429688 11.9645 0.729539 12.5787 1.32924C13.1929 1.92894 13.5 2.76079 13.5 3.82478C13.5 4.8936 12.9462 5.98177 11.8387 7.08929L7.3192 11.442C7.23214 11.529 7.12574 11.5725 7 11.5725Z"
                              fill="#D3D3D3"
                            />
                          </svg>
                        </>
                      )}
                    </button>
                  </div>
                  <div className="w-full flex items-center justify-end">
                    <div className="py-[5px] px-[6px] w-[67px] h-[28px] bg-white rounded-[5px] flex items-center justify-center gap-x-[3px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                      <svg
                        width="14"
                        height="11"
                        viewBox="0 0 14 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 0L8.45934 4.1459H13.1819L9.36126 6.7082L10.8206 10.8541L7 8.2918L3.1794 10.8541L4.63874 6.7082L0.818133 4.1459H5.54066L7 0Z"
                          fill="#FED500"
                        />
                      </svg>
                      <p className="w-[40px] h-[18px] font-semibold text-[12px] text-black">
                        {item?.data?.rating ? `${item.data.rating}/5` : "- / 5"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col px-[13px] pt-[9px] pb-[15px] w-full h-[213px] justify-between">
                  <p className="w-[180px] h-[49px] font-semibold text-[14px] leading-[25px]">
                    {item?.data?.productTitle?.slice(0, 33)}...
                  </p>
                  {item?.data?.storeName && (
                    <div className="flex items-center justify-start gap-x-[4px]">
                      <p className="w-auto h-[18px] font-medium text-[12px]">
                        {item?.data?.storeName.slice(0, 23)}...
                      </p>
                      {item?.data?.isVerified !== 0 && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-4 h-4 text-[#72C62F]"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                  <img
                    src={require("../../../assets/allProducts/Frame.jpg")}
                    alt=""
                    className="w-[55px] h-[17px]"
                  />
                  <p className="w-full h-[24px] text-[#FF6300] font-semibold mt-[3px]">
                    {getCurrencySymbol()}{" "}
                    {calculatedPrice(item?.data?.minPrice)}{" "}
                    <span className="w-[51px] h-[24px] text-[12px] text-black font-medium line-through">
                      {getCurrencySymbol()}{" "}
                      {calculatedPrice(item?.data?.maxPrice)}{" "}
                    </span>
                  </p>
                  <button
                    onClick={() => handleInquiryClick(item.data)}
                    className="w-[198px] h-[37px] bg-[#FF6300] text-white rounded-[5px] flex flex-row items-center justify-center font-medium text-[14px] gap-x-[8px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-send"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                    <p>Send Enquiry</p>
                  </button>
                </div>
              </button>
            </>
          ))}
      </div>
      {/* SUPPLIER SECTION */}
      {showInquiryForm && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-[10px] w-[869px] h-[657px] flex flex-col">
            <div className="w-full h-[202px] bg-[#F8F8F8] rounded-t-[10px] pt-[24px] px-[40px] flex flex-col">
              <p className="w-[125px] h-[24px] font-semibold text-[16px]">
                Product Inquiry
              </p>
              <hr className="w-[184px] h-[3px] rounded-full bg-[#FF6300] mt-[13px]" />
              lbg,,m{" "}
              <div className="mt-[18px] flex flex-row gap-x-[21px]">
                <div className="w-[118px] h-[98px] bg-white flex items-center justify-center rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                  <img
                    src={
                      selectedProduct?.images[0] || selectedProduct?.images[1]
                    }
                    alt=""
                    className="w-[48px] h-[60px]"
                  />
                </div>

                <div className="w-full flex justify-between">
                  <div className="flex flex-col gap-y-[11px] text-start items-start justify-center w-[500px]">
                    <p className="w-auto h-[21px] font-semibold text-[14px]">
                      {/* Apple Iphone 13 Pro Max ( 128 GB ) 4GB RAM */}
                      {selectedProduct?.productTitle?.slice(0, 60)}...
                    </p>
                    <p className="text-[12px] font-medium">
                      Seller : {selectedProduct?.storeName}
                    </p>
                  </div>

                  <div className="flex flex-col gap-y-[9px] justify-center items-end">
                    <div className="w-[55px] h-[18px] font-medium text-[12px] gap-x-[5px] flex items-center justify-end">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.30671 18.7119C8.06657 18.7138 7.82847 18.6678 7.60633 18.5766C7.38418 18.4853 7.18246 18.3507 7.01296 18.1806L1.71296 12.8806C1.53366 12.701 1.39381 12.4859 1.30233 12.2492C1.21086 12.0124 1.16977 11.7592 1.18171 11.5056C1.21272 10.9912 1.43577 10.5072 1.80671 10.1494L10.0005 1.94939C10.1909 1.7487 10.4208 1.58958 10.6757 1.48203C10.9307 1.37447 11.2051 1.3208 11.4817 1.32439L16.6567 1.45564C17.1265 1.46542 17.5738 1.65852 17.9031 1.99369C18.2325 2.32885 18.4177 2.77951 18.4192 3.24939L18.5505 8.41814C18.5527 8.69552 18.4984 8.97044 18.391 9.22617C18.2835 9.48191 18.1251 9.71309 17.9255 9.90564L9.74421 18.1244C9.38863 18.4984 8.90331 18.7221 8.38796 18.7494L8.30671 18.7119ZM7.90046 17.2994C7.95774 17.3559 8.02635 17.3996 8.10177 17.4276C8.17719 17.4556 8.25769 17.4673 8.33796 17.4619C8.5339 17.448 8.71818 17.3637 8.85671 17.2244L17.063 9.01814C17.1386 8.94535 17.1986 8.85795 17.2394 8.76126C17.2803 8.66457 17.301 8.56059 17.3005 8.45564L17.1692 3.28064C17.1692 3.13311 17.1106 2.99163 17.0063 2.88731C16.902 2.78299 16.7605 2.72439 16.613 2.72439L11.438 2.59314C11.3332 2.59363 11.2295 2.61487 11.133 2.65564C11.0364 2.6964 10.9489 2.75588 10.8755 2.83064L2.66921 11.0369C2.52993 11.1754 2.44556 11.3597 2.43171 11.5556C2.42631 11.6359 2.438 11.7164 2.46601 11.7918C2.49403 11.8672 2.53772 11.9359 2.59421 11.9931L7.90046 17.2994Z"
                          fill="black"
                          stroke="black"
                          stroke-width="0.5"
                        />
                        <circle
                          cx="13.5"
                          cy="6.5"
                          r="1.5"
                          stroke="black"
                          stroke-width="1.5"
                        />
                      </svg>
                      <p className="">Price :</p>
                    </div>
                    <p className="w-auto h-[21px] font-semibold text-[14px]">
                      {getCurrencySymbol()}{" "}
                      {calculatedPrice(selectedProduct?.maxPrice)} /{" "}
                      {calculatedPrice(selectedProduct?.productType)
                        ? calculatedPrice(selectedProduct.productType)
                        : "Unit"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-[40px] w-[869px] h-[455px] pt-[46px]">
              <div className="flex flex-row gap-x-[22px]">
                <div className="gap-y-[10px] flex flex-col">
                  <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                    Product Quantity
                  </p>
                  <input
                    type="text"
                    value={inquiryQuantity}
                    onChange={(e) => setInquiryQuantity(e.target.value)}
                    placeholder="Enter product quantity"
                    className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                  />
                </div>

                <div className="gap-y-[10px] flex flex-col">
                  <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                    Email ID
                  </p>
                  <input
                    type="text"
                    value={inquiryEmail}
                    onChange={(e) => setInquiryEmail(e.target.value)}
                    placeholder="Enter your email ID"
                    className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                  />
                </div>

                <div className="gap-y-[10px] flex flex-col">
                  <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                    Contact No.
                  </p>
                  <input
                    type="text"
                    value={inquiryContact}
                    onChange={(e) => setInquiryContact(e.target.value)}
                    placeholder="Enter your contact no."
                    className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                  />
                </div>
              </div>

              <div className="gap-y-[10px] flex flex-col mt-[28px]">
                <p className="w-[50px] h-[21px] font-semibold text-[14px] text-black">
                  Inquiry
                </p>
                <textarea
                  name="Inquiry"
                  id="Inquiry"
                  rows={5}
                  value={inquiryContent}
                  onChange={(e) => setInquiryContent(e.target.value)}
                  placeholder="Tell us what else do you want to know about the product"
                  className="w-[789px] h-[149px] p-[10px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
                ></textarea>
              </div>

              <div className="flex flex-row gap-x-[19px] items-center justify-center w-full h-[42px] mt-[50px]">
                <button
                  className="w-[162px] h-[42px] bg-[#FF6300] font-semibold text-[14px] rounded-[5px] text-white "
                  onClick={handleSendInquiry}
                >
                  Send Inquiry
                </button>
                <button
                  className="w-[120px] h-[42px] rounded-[5px] text-black font-semibold text-[14px] border"
                  onClick={handleCloseInquiryForm}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showInquirySent && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-[10px] w-[869px] h-[434px] flex flex-col pt-[65px] pb-[51px] items-center justify-center gap-y-[32px]">
            <p className="w-[98px] h-[98px] bg-[#0097B2] rounded-full flex items-center justify-center">
              <svg
                width="60"
                height="46"
                viewBox="0 0 60 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.1983 42.8495C21.5731 43.477 20.6874 44 19.9059 44C19.1245 44 18.2388 43.4509 17.5876 42.8233L3 28.1805L7.63676 23.5261L19.932 35.868L52.4414 3L57 7.73278L22.1983 42.8495Z"
                  fill="white"
                  stroke="white"
                  stroke-width="3"
                />
              </svg>
            </p>
            <h3 className="w-[113px] h-[24px] font-semibold text-[16px] text-black text-start">
              Inquiry Sent !!
            </h3>
            <p className="w-[305px] h-[52px] font-medium text-[14px] text-black text-center">
              Your inquiry has been sent to the seller. We will notify you once
              the seller responds.
            </p>
            <div className="w-full h-[42px] flex flex-row gap-x-[19px] items-center justify-center">
              <button
                className="w-[162px] h-[42px] bg-[#FF6300] rounded-[5px] text-white font-semibold text-[14px]"
                onClick={handleViewAllInquiries}
              >
                View All Inquiries
              </button>
              <button
                className="w-[120px] h-[42px] rounded-[5px] text-black font-semibold text-[14px] border"
                onClick={handleCloseInquirySent}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductsCard;
